import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from '../../config';
import Title from './title';

const SuperAdminCompanies = () => {
  const user = useSelector(state => state.user.currentUser);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  // Создание компании
  const [showCreateCompany, setShowCreateCompany] = useState(false);
  const [newCompany, setNewCompany] = useState({
    companyName: '',
    adminPhone: ''
  });

  useEffect(() => {
    if (user?.role === 'super_admin') {
      loadCompanies();
    }
  }, [user]);

  const loadCompanies = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${config.apiUrl}/api/company`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setCompanies(res.data.companies);
    } catch (error) {
      console.error('Ошибка загрузки компаний:', error);
      alert('Ошибка загрузки компаний');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateCompany = async () => {
    try {
      if (!newCompany.companyName.trim() || !newCompany.adminPhone.trim()) {
        alert('Заполните все поля');
        return;
      }

      await axios.post(`${config.apiUrl}/api/company`, newCompany, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      alert('Компания создана успешно!');
      setNewCompany({ companyName: '', adminPhone: '' });
      setShowCreateCompany(false);
      loadCompanies();
    } catch (error) {
      console.error('Ошибка создания компании:', error);
      alert(error.response?.data?.message || 'Ошибка создания компании');
    }
  };

  const handleToggleCompanyStatus = async (companyId, isActive) => {
    try {
      await axios.put(`${config.apiUrl}/api/superadmin/companies/${companyId}/status`, {
        isActive: !isActive
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      alert(`Компания ${!isActive ? 'активирована' : 'деактивирована'} успешно!`);
      loadCompanies();
    } catch (error) {
      console.error('Ошибка изменения статуса компании:', error);
      alert('Ошибка изменения статуса компании');
    }
  };

  const handleDeleteCompany = async (companyId) => {
    if (!window.confirm('Вы уверены, что хотите удалить эту компанию?')) {
      return;
    }

    try {
      await axios.delete(`${config.apiUrl}/api/superadmin/companies/${companyId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      alert('Компания удалена успешно!');
      loadCompanies();
    } catch (error) {
      console.error('Ошибка удаления компании:', error);
      alert(error.response?.data?.message || 'Ошибка удаления компании');
    }
  };

  if (loading) {
    return (
      <div className="my-cargo mainAdmin">
        <Title text="Компании" />
        <div className="loadpage">
          <p>Загрузка...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="my-cargo mainAdmin">
      <Title text="Компании" />

      <div className="section-my-cargo">
        <div style={{ width: '100%', padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3>Управление компаниями</h3>
            <button
              className="btn btn-primary"
              onClick={() => setShowCreateCompany(true)}
              style={{ padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
            >
              Создать компанию
            </button>
          </div>

          {showCreateCompany && (
            <div style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: '20px' }}>
              <h4>Создание новой компании</h4>
              <div style={{ marginBottom: '10px' }}>
                <input
                  type="text"
                  placeholder="Название компании"
                  value={newCompany.companyName}
                  onChange={(e) => setNewCompany({ ...newCompany, companyName: e.target.value })}
                  style={{ width: '100%', padding: '8px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
                <input
                  type="text"
                  placeholder="Телефон администратора"
                  value={newCompany.adminPhone}
                  onChange={(e) => setNewCompany({ ...newCompany, adminPhone: e.target.value })}
                  style={{ width: '100%', padding: '8px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>
              <div>
                <button
                  className="btn btn-success"
                  onClick={handleCreateCompany}
                  style={{ padding: '8px 16px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', marginRight: '10px' }}
                >
                  Создать
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowCreateCompany(false)}
                  style={{ padding: '8px 16px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                >
                  Отмена
                </button>
              </div>
            </div>
          )}

          <div className="companies-list" style={{ display: 'grid', gap: '15px' }}>
            {companies.map((company) => (
              <div key={company._id} className="company-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px', border: '1px solid #ddd', borderRadius: '8px', background: '#f8f9fa' }}>
                <div className="company-info">
                  <h3>{company.companyName}</h3>
                  <p>Владелец: {company.owner?.name || 'Не назначен'}</p>
                  <p>Телефон: {company.owner?.phone || 'Не указан'}</p>
                  <p>Статус: {company.isActive ? 'Активна' : 'Неактивна'}</p>
                </div>
                <div>
                  <button
                    className={`btn ${company.isActive ? 'btn-warning' : 'btn-success'}`}
                    onClick={() => handleToggleCompanyStatus(company._id, company.isActive)}
                    style={{ padding: '6px 12px', marginRight: '10px', border: 'none', borderRadius: '4px', cursor: 'pointer', color: 'white', backgroundColor: company.isActive ? '#ffc107' : '#28a745' }}
                  >
                    {company.isActive ? 'Деактивировать' : 'Активировать'}
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => handleDeleteCompany(company._id)}
                    style={{ padding: '6px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', color: 'white', backgroundColor: '#dc3545' }}
                  >
                    Удалить
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminCompanies;